var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-flex-cfsc",attrs:{"id":"hotMapBox"}},[_c('div',{style:({width:'8.4rem',height:_vm.mapHight}),attrs:{"id":"hotMapContent"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }